export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'UtcWOaWJ9fXBMaGlxRI1ht7evPZUJwY0',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'UtcWOaWJ9fXBMaGlxRI1ht7evPZUJwY0',
        audience: 'https://crew-time/api',
    }
}